<template>
    <div class="login">

        <div class="loginCon">
            <div class="left">
                <el-carousel trigger="click">
                    <el-carousel-item v-for="item in bannerList">
                        <a :href="item.linkurl" target="_blank">
                            <img style="width:100%" :src="item.linkimg" alt="">
                        </a>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="right">
                <div class="back">
                    <a :href="homepage">返回首页</a>
                </div>
                <el-card class="login-box">

                    <div slot="header" class="clearfix">
                        <h4>{{rolename}}登录<span style="font-size:14px">v1.0</span></h4>
                    </div>

                    <div class="text item">
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="密码登录" name="first">
                                <login-pwd 
                                    :key="timer"
                                    :roleCode="roleCode"
                                    @losename="losenameDialog"
                                    @losePwd="losePwdDialog"
                                    @tixing="tixingDialog">
                                </login-pwd>
                            </el-tab-pane>
                            <el-tab-pane label="短信登录" name="second">
                                <login-phone 
                                    :roleCode="roleCode"
                                    :key="timer"
                                    @bindClick="bindClick">
                                </login-phone>
                            </el-tab-pane>
                            <el-tab-pane label="CA登录" name="third">
                                <Login-CA 
                                    :roleCode="roleCode"
                                    :source="source" 
                                    :key="timer">
                                </Login-CA>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    
                    <div class="wxlogin" style="width: 100px;position">
                        <a class="weixin_login" @click="wxlogin">
                            <img src="./images/weixin.png" style="width: 25px;float:left"/>
                            <span style="font-size: 16px;float:left;margin-left:5px">微信登录</span>   
                        </a>
                    </div>

                </el-card>
            </div>
        </div>

        <!-- 弹窗 -->
        <my-dialog v-model="dialogVisible" width="500px" :title="dialogTitle" @close="close">
            <component v-if="dialogVisible" :is="dialogComponent" :data="dialogData" @cancle="dialogClose"></component>
        </my-dialog>

        <!-- 选择单位弹窗 -->
        <my-dialog
            v-model="dwDialogVisible"
            :title="dwDialogTitle"
            width="800px">
                <choice-account 
                    :bindInfo="bindInfo"
                    :dwType="dwType"
                    v-if="dwDialogVisible">
                </choice-account>
        </my-dialog>     

        <el-dialog
            append-to-body
            title="提示"
            :visible.sync="copydialogVisible"
            width="30%">
            <p>请发申请至首页邮箱
                <a @click="CopyMailAddress()" style="color: red" id="mailAddress" title="点击即可复制地址">
                    {{phoneNotUse.emailAddress}}
                </a>（加盖公章）进行登录名找回、密码重置。
                <br/>
                <a :href='phoneNotUse.mobanUrl' style="color: red">
                    下载申请模板
                </a>
            </p>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="copydialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
    import LoginPwd from './components/login-pwd'//密码登录
    import LoginPhone from './components/login-phone'
    import LoginCA from './components/login-CA'
    import ChoiceAccount from './components/choice-account'//选择单位

    import loginAd from './images/login_ad.png';

    import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page';

    export default {
        mixins: [DIALOG_LIST_PAGE_MIXIN],
        components: {
            LoginPwd,LoginPhone,LoginCA,ChoiceAccount,
            LoseName:()=>import('./components/lose-name'),//忘记登录名
            LosePassword: () => import('./components/lose-password')//忘记密码
        },
        data: () => ({
            homepage:"",
            activeName: 'first',
            loginBg:window._config.loginBg,
            bannerList:[
                { linkimg:loginAd, linkurl:''}
            ],
            loginimgtype:'',
            rolename:'',
            roleCode:'',

            // dialog
            dialogComponent: '',
            dialogData: {},
            dialogTitle:'',

            phoneNotUse:window._config.phoneNotUse,

            copydialogVisible:false,

            source: '',//随机数
            timer:new Date().getTime(),//时间戳 用于重新加载子组件

            // 单位弹窗
            dwDialogVisible:false,
            dwDialogTitle:'选择登录单位',
            bindInfo:{},
            dwType:'',

        }),
        watch: {

        },
        
        methods: {
            // w微信登录
            wxlogin(){
                window.localStorage.setItem('itemDate', null);
                window.open('/api/auth/third/wechat/login');
            },
            // 微信扫码后回调登录方法
            WxLoginChoice(openid, state){
                var that = this;
                $.get('/api/auth/third/wechat/account', {
                    openid: openid,
                    state: state,
                    userType:that.roleCode
                }, (res,data) => {
                    window.localStorage.removeItem('itemDate');
                    if(res.result){
                        that.$store.dispatch('views/login', {
                            obj:that.form
                        });
                    }else{
                        if(res.msg){
                            ShowMsg(res.msg,'error');
                        }else{
                            ShowMsg(res.errors.captcha|| res.errors.password,'error');
                        }
                    }
                    
                })
            },

            // 获取banner图
            getloginimg(){
                var that = this;
                that.$get(`/web/index/information/getloginimg.json`, {
                    type:that.loginimgtype,
                }, data => {
                    if(data.length){
                        that.bannerList = data;
                    }
                    
                })
            },
            // 忘记登录名
            losenameDialog() {
                this.dialogTitle = '找回登录名'
                this.dialogComponent = 'lose-name';
                this.dialogShow();
            },
            // 忘记密码
            losePwdDialog(){
                this.dialogTitle = '找回密码'
                this.dialogComponent = 'lose-password';
                this.dialogShow();
            },
            // 关闭弹窗
            close(){
                this.timer = new Date().getTime();
            },
            // 提醒
            tixingDialog(){
                this.copydialogVisible = true;
            },
            CopyMailAddress() {
                var mailAddressText=document.getElementById("mailAddress").innerText;
                var oInput = document.createElement('input');
                oInput.value  = mailAddressText;
                document.body.appendChild(oInput);
                oInput.select();
                document.execCommand("copy");
                oInput.className = 'oInput';
                oInput.style.display='none';
                ShowMsg('已复制邮箱地址');
            },
            // 多个单位绑定手机
            bindClick(val){
                this.bindInfo = val;
                this.bindInfo.userType = this.roleCode;
                this.dwType = 'mobeil';
                this.dwDialogVisible = true;
            }
        },
        mounted() {
            var that = this;
            this.homepage = !!that.getQuery('indexUrl') ? window.atob(that.getQuery('indexUrl')) : '/';
            // that.timer = new Date().getTime();
            // 获取身份信息
            that.$get(`${this.getGetters('bidUrl')}/admin/unified/queryLoginInitInfo.json`, {
                role:that.getQuery('mRole'),
            }, data => {
                // 判断身份
                if(data.roleCode=='agent'){
                    that.loginimgtype = window._config.dlloginad;
                }else{
                    that.loginimgtype = window._config.zbrloginad;
                }
                that.roleCode = data.roleCode;
                that.rolename = data.roleName;
                that.source = data.randomString;
                if(data.isLogin){
                    that.goto({
                        path: '/home'
                        // path: '/bidding/workbench/index'
                    });
                    
                }
                that.getloginimg()
            });

            // 微信扫码页面回调
            window.addEventListener('storage', function (e) {
                if (e.key == 'itemDate' && e.newValue != null) {
                    var storageData = JSON.parse(e.newValue);
                    that.WxLoginChoice(storageData.openid, storageData.state);
                }
            });
        },

    }
</script>

<style scoped lang="scss">

    .login{ background:url(./images/login_bg.jpg) no-repeat;  background-size: cover !important; width: 100%; height: 100%; overflow: hidden;}
    .loginCon{ width: 1020px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); box-shadow: 1px 1px 10px #ccc; border-radius: 10px;}
    .loginCon .left{ width: 530px; height: 530px; float: left; }
    .loginCon .right{ width: 490px; height: 530px; float: right; background: #fff; border-top-right-radius: 10px; border-bottom-right-radius: 10px;position: relative; }
    .loginCon .right .back{ margin: 15px 0; text-align: right; padding-right: 35px;}
    .loginCon .right .back a{ color: #4f4f4f; font-size: 14px; }
    /deep/ .el-card__header{ text-align: center; border-bottom: none;  }
    /deep/ .el-card__header h4{ color: #008eff; font-size: 24px; font-weight: 400; font-weight: 400; }
    /deep/ .el-card{ border: none; -webkit-box-shadow:none;box-shadow:none}
    /deep/ .el-card__header{ padding: 10px 0; }
    /deep/ .el-card__body{ padding: 0 85px; }
    /deep/ .el-tabs__nav-wrap::after{ background: none; }
    /deep/ .el-tabs__nav-scroll{ text-align: center; }
    /deep/ .el-tabs__nav{ float: none; }
    /deep/ .el-tabs__active-bar{ width: 100px !important; left: 3px; }
    /deep/ .el-tabs__item{ font-size: 18px; }
    /deep/ .el-input--small .el-input__inner{ height: 42px; line-height: 42px;}
    /deep/ .btn-row{ margin-top: 0 !important;}
    .CAcon p{ margin-top: 15px; }
    /deep/ .el-carousel__container{ height: 530px; }
    /deep/ .el-dialog__body{ padding: 15px 20px;}
    .wxlogin{ position: absolute; bottom:40px; left: 200px; }
</style>
